import { Enum } from "./Enum";

export const E_UNIT_TYPE = Object.freeze({
  MAIN: "/unit-type",
  LISTING: "/unit-type/listing",
  UNIT_TYPE_ID: (id: string = ":id") => `/unit-type/${id}`,
});

export type E_UNIT_TYPE = Enum<typeof E_UNIT_TYPE>;
